export function selectResources() {
    return (state) => state.resources.current;
}